import { SendMetrics } from '@jusbrasil-web/shared-utils-events'

import { MetricsProperties } from './types'

export type sendCopyMetricsProps = {
  sendMetrics: SendMetrics
  userPid: string | null
  eventName?: string
  metricsProperties: MetricsProperties
}

export const pageOriginIsSerp = (metricsProperties: MetricsProperties) =>
  (typeof metricsProperties.referrer === 'string' &&
    metricsProperties.referrer.includes('/busca')) ||
  metricsProperties.origin === 'serp'

export const sendCopyMetrics = ({
  sendMetrics,
  userPid,
  metricsProperties,
  eventName = 'Doc.CopiedContent',
}: sendCopyMetricsProps) => {
  sendMetrics(eventName, userPid, metricsProperties)

  if (pageOriginIsSerp(metricsProperties)) {
    sendMetrics('Search.CopiedContent', userPid, {
      app_id: metricsProperties.app_id,
      doc_id: metricsProperties.doc_id,
      from_component: metricsProperties.from_component,
    })
  }
}
